define([
    'common/ui/view/svg/node',
    'common/ui/view/svg/text/label',
    'common/ui/view/svg/util',
    'victor',
], function(
    NodeView,
    TextlabelView,
    SVGUtil,
    Victor
) {
    var PortView = NodeView.extend({
        className: 'port',
        draggable: true,
        shapeViewClass: 'rect',
        shapeViewOptions: {
            width: 64,
            height: 64
        },
        direction: function() {
            return this.model.get('degree');
        },
        locator: function() {
            return this.nodeView
                .getBorderPoint(this.getDirection(), 20)
                .clone()
                .subtract(this.nodeView.getCenterPoint());
        },
        getDirection: function() {
            if(_.isFunction(this.direction)) {
                return this.direction();
            }
            else {
                return this.direction;
            }
        },
        initialize: function(options) {
            PortView.__super__.initialize.call(this, options);
            this.nodeView = options.nodeView;
            this.listenTo(this.nodeView, 'move', function(){
                this.trigger('move')
            });
        },
        getCenterPoint: function() {
            return this._getCenterPoint().clone()
                .add(this.nodeView.getCenterPoint());
        },

        getBorderPoint: function(direction, offset) {
            return this.nodeView.getBorderPoint(
                this.getDirection(), offset);
        },

        getBorderTangent: function(direction, offset) {
            return this.nodeView.getBorderTangent(
                this.getDirection(), offset);
        },

        onRender: function() {
            PortView.__super__.onRender.call(this);
            this.renderName();
        },
        onSetDirection: function() {

        },
        onDrag: function(pos, dpos) {
            var direction = pos.clone().subtract(this.nodeView.getCenterPoint());
            var pos = this.nodeView.getBorderPoint(direction, 20).clone()
                .subtract(this.nodeView.getCenterPoint());
            this.pos = pos;
            this.onSetDirection(direction.norm());
            this.renderName();
            this.$el
                .attr('transform', SVGUtil.transform(this._getCenterPoint()));
            this.nodeView.trigger('move', this.model);
        },
        onDragEnd: function(pos) {
            var direction = pos.clone().subtract(this.nodeView.getCenterPoint());
            // var angle = this._getCenterPoint().clone().invertY().horizontalAngleDeg() + 360;
            this.onSetDirection(direction.norm());
            this.renderName();
            this.nodeView.trigger('move', this.model);
        },

        renderName: function() {
            this.$el.selectAll('.port-name').remove();
            var normal = this.nodeView.getBorderTangent(
                this.getDirection()
            );
            var nameView = new TextlabelView({
                offset: normal.multiplyScalar(64).toObject(),
                size: 30,
                text: this.model.get('name')
            });
            nameView.$el.classed('port-name', true);
            this.$el.append(nameView.render().el);
        }
    });

    return PortView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/port.js